<template>
  <VueFinalModal
    :click-to-close="clickToClose"
    :hide-overlay="hideOverlay"
    class="modal__container"
    overlay-class="!fixed !bg-slate-900/60 dark:!bg-zinc-900/60"
    :content-class="contentClass()"
    :overlay-transition="{ css: false }"
    @click-outside="onClickOutside"
  >
    <div class="w-full dark:text-zinc-300" :data-testid="dataTestid">
      <button
        v-if="!hideClose"
        @click.stop.prevent="$emit('close')"
        data-testid="modal-close"
        class="absolute rounded-full z-10"
        :class="[closeButtonClasses, closeButtonThemeClasses]"
      >
        <Icon name="general.crossLight" size="base" />
      </button>

      <div class="modal__content">
        <slot />
      </div>
    </div>
  </VueFinalModal>
</template>

<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal';
import { Icon } from './../icon';

export interface ConfirmModalProps {
  dataTestid?: string;
  hideClose?: boolean;
  hideOverlay?: boolean;
  clickToClose?: boolean;
  onClickOutside?: () => void;
  noBorder?: boolean;
  closeButtonInset?: 'default' | 'large';
  closeButtonTheme?: 'default' | 'light';
}

const props = withDefaults(defineProps<ConfirmModalProps>(), { clickToClose: true, closeButtonInset: 'default', closeButtonTheme: 'default' });

const closeButtonClasses = {
  'p-1 top-4 right-4': props.closeButtonInset === 'default',
  'p-2 top-8 right-6': props.closeButtonInset === 'large',
};

const closeButtonThemeClasses = {
  'bg-white text-slate-700 dark:bg-zinc-800 dark:text-zinc-300 hover:bg-slate-100 dark:hover:bg-zinc-700 dark:hover:text-zinc-200':
    props.closeButtonTheme === 'default',
  'bg-white text-slate-700 hover:bg-slate-100': props.closeButtonTheme === 'light',
};

const contentClass = () => {
  return props.noBorder ? 'modal no-border' : 'modal';
};
</script>
